import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { Box, Card, Grid, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import HeaderCustom from "../../components/header/HeaderCustom";
import db, { firebase } from "../../firebase-config"
import IconButton from "@mui/material/IconButton";
import LensIcon from '@mui/icons-material/Lens';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';


// --- Styled Components ---
const Root = styled(Box)({
  background: "#000",
  color: "#fff",
  padding: "16px 4px",
});

const InfoCard = styled(Card)(({ $empty }) => ({
  position: "relative",
  borderRadius: 16,
  background: $empty ? "#cfcfcf" : "#f9c97b",
  padding: 2,
  color: "#000",
  fontWeight: 500,
  minHeight: 550,
}));

const CornerNumber = styled(Box)({
  // position: "absolute",
  // top: 8,
  // left: 10,
  fontSize: 48,
  fontWeight: 700,
  color: "#111",
});

const TimerCircle = styled(Box)(({ percent }) => ({
  width: "clamp(50px, 16vw, 150px)",
  height: "clamp(50px, 16vw, 150px)",
  borderRadius: "50%",
  background: `conic-gradient(#ff8c00 ${percent}%, #ccc ${percent}%)`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  transition: "background 0.5s linear",
}));

const TimerInner = styled(Box)({
  position: "absolute",
  width: "clamp(30px, 14vw, 120px)",
  height: "clamp(30px, 14vw, 120px)",
  borderRadius: "50%",
  background: "#000",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  color: "#fff",
});

const Header = styled(Typography)({
  fontWeight: 600,
  fontSize: 36,
  lineHeight: "60px",
});
const LabelBox = styled(Typography)({
  fontWeight: 600,
  fontSize: 36,
  lineHeight: "60px",
});
const Labelvalue = styled(Typography)({
  fontWeight: 600,
  fontSize: 36,
  lineHeight: "60px",
  color: "#2f9281",
});



export default function ChickenRestDashboard() {
  const TIMER_DURATION = 1800;
  const display = useSelector(state => state.auth.email);
  const [shift, setShift] = useState({});
  const [checkenLairage, setCheckenLairage] = useState([]);

  const [openLairage01, setOpenLairge01] = useState();
  const [addQueueNumber01, setAddQueueNumber01] = useState(null);
  const [addLineNumber01, setAddLineNumber01] = useState(null);
  const [addLicensePlate01, setAddLicensePlate01] = useState(null);
  const [addFarmName01, setAddFarmName01] = useState(null);

  const [openLairage02, setOpenLairge02] = useState();
  const [addQueueNumber02, setAddQueueNumber02] = useState(null);
  const [addLineNumber02, setAddLineNumber02] = useState(null);
  const [addLicensePlate02, setAddLicensePlate02] = useState(null);
  const [addFarmName02, setAddFarmName02] = useState(null);

  const [openLairage03, setOpenLairge03] = useState();
  const [addQueueNumber03, setAddQueueNumber03] = useState(null);
  const [addLineNumber03, setAddLineNumber03] = useState(null);
  const [addLicensePlate03, setAddLicensePlate03] = useState(null);
  const [addFarmName03, setAddFarmName03] = useState(null);

  const [openLairage04, setOpenLairge04] = useState();
  const [addQueueNumber04, setAddQueueNumber04] = useState(null);
  const [addLineNumber04, setAddLineNumber04] = useState(null);
  const [addLicensePlate04, setAddLicensePlate04] = useState(null);
  const [addFarmName04, setAddFarmName04] = useState(null);
  const [timerSeconds01, setTimerSeconds01] = useState(0);
  const [isTimerRunning01, setIsTimerRunning01] = useState(false);

  const [timerSeconds02, setTimerSeconds02] = useState(0);
  const [isTimerRunning02, setIsTimerRunning02] = useState(false);

  const [timerSeconds03, setTimerSeconds03] = useState(0);
  const [isTimerRunning03, setIsTimerRunning03] = useState(false);

  const [timerSeconds04, setTimerSeconds04] = useState(0);
  const [isTimerRunning04, setIsTimerRunning04] = useState(false);

  const [openCloseLairage01, setOpenCloseLairge01] = useState();
  const [openCloseLairage02, setOpenCloseLairge02] = useState();
  const [openCloseLairage03, setOpenCloseLairge03] = useState();
  const [openCloseLairage04, setOpenCloseLairge04] = useState();


  const useTimerEffect = (isRunning, timer, setTimer) => {
    useEffect(() => {
      let interval;
      if (isRunning && timer > 0) {
        interval = setInterval(() => {
          setTimer(prev => Math.max(prev - 1, 0));
        }, 1000);
      }
      return () => clearInterval(interval);
    }, [isRunning, timer]);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const handleClickOpenLairage01 = () => {
    setOpenLairge01(true);
  };

  const handleCloseLairage01 = () => {
    setOpenLairge01(false);
  };

  const handleClickOpenLairage02 = () => {
    setOpenLairge02(true);
  };

  const handleCloseLairage02 = () => {
    setOpenLairge02(false);
  };

  const handleClickOpenLairage03 = () => {
    setOpenLairge03(true);
  };

  const handleCloseLairage03 = () => {
    setOpenLairge03(false);
  };

  const handleClickOpenLairage04 = () => {
    setOpenLairge04(true);
  };

  const handleCloseLairage04 = () => {
    setOpenLairge04(false);
  };

  const handleClickOpenCloseLairage01 = () => {
    setOpenCloseLairge01(true);
  };

  const handleCloseCloseLairage01 = () => {
    setOpenCloseLairge01(false);
  };

  const handleClickOpenCloseLairage02 = () => {
    setOpenCloseLairge02(true);
  };

  const handleCloseCloseLairage02 = () => {
    setOpenCloseLairge02(false);
  };

  const handleClickOpenCloseLairage03 = () => {
    setOpenCloseLairge03(true);
  };

  const handleCloseCloseLairage03 = () => {
    setOpenCloseLairge03(false);
  };

  const handleClickOpenCloseLairage04 = () => {
    setOpenCloseLairge04(true);
  };

  const handleCloseCloseLairage04 = () => {
    setOpenCloseLairge04(false);
  };

  const handleAddLairage01 = (event) => {
    if (event.target.name === "queue_number01") {
      setAddQueueNumber01(event.target.value);
    }
    if (event.target.name === "line_number01") {
      setAddLineNumber01(event.target.value);
    }
    if (event.target.name === "license_plate01") {
      setAddLicensePlate01(event.target.value);
    }
    if (event.target.name === "farm_name01") {
      setAddFarmName01(event.target.value);
    }
  };

  const handleAddLairage02 = (event) => {
    if (event.target.name === "queue_number02") {
      setAddQueueNumber02(event.target.value);
    }
    if (event.target.name === "line_number02") {
      setAddLineNumber02(event.target.value);
    }
    if (event.target.name === "license_plate02") {
      setAddLicensePlate02(event.target.value);
    }
    if (event.target.name === "farm_name02") {
      setAddFarmName02(event.target.value);
    }
  };

  const handleAddLairage03 = (event) => {
    if (event.target.name === "queue_number03") {
      setAddQueueNumber03(event.target.value);
    }
    if (event.target.name === "line_number03") {
      setAddLineNumber03(event.target.value);
    }
    if (event.target.name === "license_plate03") {
      setAddLicensePlate03(event.target.value);
    }
    if (event.target.name === "farm_name03") {
      setAddFarmName03(event.target.value);
    }
  };

  const handleAddLairage04 = (event) => {
    if (event.target.name === "queue_number04") {
      setAddQueueNumber04(event.target.value);
    }
    if (event.target.name === "line_number04") {
      setAddLineNumber04(event.target.value);
    }
    if (event.target.name === "license_plate04") {
      setAddLicensePlate04(event.target.value);
    }
    if (event.target.name === "farm_name04") {
      setAddFarmName04(event.target.value);
    }
  };

  useEffect(() => {
    function updateShift() {
      const now = new Date();
      const hour = now.getHours();

      if (hour >= 6 && hour < 18) {
        // 06:00 - 17:59 → กลางวัน
        setShift({ SHIFT: "D" });
      } else {
        // 18:00 - 05:59 → กลางคืน
        setShift({ SHIFT: "N" });
      }
    }

    updateShift(); // เรียกครั้งแรกตอน mount

    const timer = setInterval(updateShift, 60 * 1000); // อัพเดททุก 1 นาที
    return () => clearInterval(timer); // clear ตอน unmount
  }, []);

  const handleSubmitAddLairage01 = async () => {
    try {
      const collectionName = "prod_mes_ignition_slaughter_chicken_lairage";
      const documentName = "thailand4070ck_koratlairage_01";

      const docRef = db.collection(collectionName).doc(documentName);

      // ตรวจสอบว่า add_target มีค่าหรือไม่
      // if (!addQueueNumber01 || isNaN(addQueueNumber01)) {
      //   alert("กรุณากรอก spray water เป็นตัวเลขที่ถูกต้อง!");
      //   return;
      // }

      const data = {
        ARRIVAL_TIMESTAMP: firebase.firestore.FieldValue.serverTimestamp(),
        FARM_NAME: addFarmName01,
        LICENSE_PLATE: addLicensePlate01,
        LINE_NUMBER: addLineNumber01,
        QUEUE_NUMBER: addQueueNumber01,
        STATUS_LAIRAGE: true,
        USER: display
      };

      await docRef.set(data);

      setAddFarmName01(null)
      setAddLicensePlate01(null)
      setAddLineNumber01(null)
      setAddQueueNumber01(null);
      setOpenLairge01(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดต");
    }
  };

  const handleSubmitCloseLairage01 = async () => {
    try {
      const collectionName = "prod_mes_ignition_slaughter_chicken_lairage";
      const documentName = "thailand4070ck_koratlairage_01";

      const docRef = db.collection(collectionName).doc(documentName);
      const data = {
        STATUS_LAIRAGE: false,
        USER: display
      };

      await docRef.set(data);
      setOpenCloseLairge01(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดต");
    }
  };

  const handleSubmitAddLairage02 = async () => {
    try {
      const collectionName = "prod_mes_ignition_slaughter_chicken_lairage";
      const documentName = "thailand4070ck_koratlairage_02";

      const docRef = db.collection(collectionName).doc(documentName);

      const data = {
        ARRIVAL_TIMESTAMP: firebase.firestore.FieldValue.serverTimestamp(),
        FARM_NAME: addFarmName02,
        LICENSE_PLATE: addLicensePlate02,
        LINE_NUMBER: addLineNumber02,
        QUEUE_NUMBER: addQueueNumber02,
        STATUS_LAIRAGE: true,
        USER: display
      };

      await docRef.set(data);

      setAddFarmName02(null)
      setAddLicensePlate02(null)
      setAddLineNumber02(null)
      setAddQueueNumber02(null);
      setOpenLairge02(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดต");
    }
  };

  const handleSubmitCloseLairage02 = async () => {
    try {
      const collectionName = "prod_mes_ignition_slaughter_chicken_lairage";
      const documentName = "thailand4070ck_koratlairage_02";

      const docRef = db.collection(collectionName).doc(documentName);

      const data = {
        STATUS_LAIRAGE: false,
        USER: display
      };

      await docRef.set(data);
      setOpenCloseLairge02(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดต");
    }
  };

  const handleSubmitAddLairage03 = async () => {
    try {
      const collectionName = "prod_mes_ignition_slaughter_chicken_lairage";
      const documentName = "thailand4070ck_koratlairage_03";

      const docRef = db.collection(collectionName).doc(documentName);

      const data = {
        ARRIVAL_TIMESTAMP: firebase.firestore.FieldValue.serverTimestamp(),
        FARM_NAME: addFarmName03,
        LICENSE_PLATE: addLicensePlate03,
        LINE_NUMBER: addLineNumber03,
        QUEUE_NUMBER: addQueueNumber03,
        STATUS_LAIRAGE: true,
        USER: display
      };

      await docRef.set(data);

      setAddFarmName03(null)
      setAddLicensePlate03(null)
      setAddLineNumber03(null)
      setAddQueueNumber03(null);
      setOpenLairge03(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดต");
    }
  };

  const handleSubmitCloseLairage03 = async () => {
    try {
      const collectionName = "prod_mes_ignition_slaughter_chicken_lairage";
      const documentName = "thailand4070ck_koratlairage_03";

      const docRef = db.collection(collectionName).doc(documentName);

      const data = {
        STATUS_LAIRAGE: false,
        USER: display
      };

      await docRef.set(data);

      setOpenCloseLairge03(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดต");
    }
  };

  const handleSubmitAddLairage04 = async () => {
    try {
      const collectionName = "prod_mes_ignition_slaughter_chicken_lairage";
      const documentName = "thailand4070ck_koratlairage_04";

      const docRef = db.collection(collectionName).doc(documentName);

      const data = {
        ARRIVAL_TIMESTAMP: firebase.firestore.FieldValue.serverTimestamp(),
        FARM_NAME: addFarmName04,
        LICENSE_PLATE: addLicensePlate04,
        LINE_NUMBER: addLineNumber04,
        QUEUE_NUMBER: addQueueNumber04,
        STATUS_LAIRAGE: true,
        USER: display
      };

      await docRef.set(data);

      setAddFarmName04(null)
      setAddLicensePlate04(null)
      setAddLineNumber04(null)
      setAddQueueNumber04(null);
      setOpenLairge04(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดต");
    }
  };

  const handleSubmitCloseLairage04 = async () => {
    try {
      const collectionName = "prod_mes_ignition_slaughter_chicken_lairage";
      const documentName = "thailand4070ck_koratlairage_04";

      const docRef = db.collection(collectionName).doc(documentName);

      const data = {
        STATUS_LAIRAGE: false,
        USER: display
      };

      await docRef.set(data);

      setOpenCloseLairge04(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดต");
    }
  };


  useEffect(() => {
    const subscribercheckenLairage = db
      .collection("prod_mes_ignition_slaughter_chicken_lairage")
      .onSnapshot((querySnapshot) => {
        const checkenLairageData = querySnapshot.docs.map(doc => ({
          ...doc.data(),
          id: doc.id,
        }));
        setCheckenLairage(checkenLairageData);
      });
    return () => {
      subscribercheckenLairage();
    }
  }, []);

  const findMachine = (key) => (checkenLairage || []).find((a) => (a?.MACHINE_NAME || "").includes(key)) || null;
  const findID = (key) => (checkenLairage || []).find((a) => (a?.id || "").includes(key)) || null;

  const detail_lairage01 = findID("thailand4070ck_koratlairage_01");
  const detail_lairage02 = findID("thailand4070ck_koratlairage_02");
  const detail_lairage03 = findID("thailand4070ck_koratlairage_03");
  const detail_lairage04 = findID("thailand4070ck_koratlairage_04");

  const tempguard_01 = findMachine("tempguard_01");
  const tempguard_03 = findMachine("tempguard_03");
  const tempguard_04 = findMachine("tempguard_04");
  const tempguard_05 = findMachine("tempguard_05");

  const initTimerFromTimestamp = (timestamp, setTimer, setRun) => {
    if (!timestamp) return;
    const startTime = timestamp.toDate();
    const now = new Date();
    const diffSeconds = Math.floor((now - startTime) / 1000);
    const timeLeft = TIMER_DURATION - diffSeconds;

    setTimer(timeLeft > 0 ? timeLeft : 0);
    setRun(timeLeft > 0);
  };

  useEffect(() => {
    initTimerFromTimestamp(detail_lairage01?.ARRIVAL_TIMESTAMP, setTimerSeconds01, setIsTimerRunning01);
    initTimerFromTimestamp(detail_lairage02?.ARRIVAL_TIMESTAMP, setTimerSeconds02, setIsTimerRunning02);
    initTimerFromTimestamp(detail_lairage03?.ARRIVAL_TIMESTAMP, setTimerSeconds03, setIsTimerRunning03);
    initTimerFromTimestamp(detail_lairage04?.ARRIVAL_TIMESTAMP, setTimerSeconds04, setIsTimerRunning04);
  }, [detail_lairage01, detail_lairage02, detail_lairage03, detail_lairage04]);

  useTimerEffect(isTimerRunning01, timerSeconds01, setTimerSeconds01);
  useTimerEffect(isTimerRunning02, timerSeconds02, setTimerSeconds02);
  useTimerEffect(isTimerRunning03, timerSeconds03, setTimerSeconds03);
  useTimerEffect(isTimerRunning04, timerSeconds04, setTimerSeconds04);

  const percent01 = Math.round((timerSeconds01 / 1800) * 100);
  const color01 = timerSeconds01 > 0 ? "#ff8c00" : "#2f9281";

  const percent02 = Math.round((timerSeconds02 / 1800) * 100);
  const color02 = timerSeconds02 > 0 ? "#ff8c00" : "#2f9281";

  const percent03 = Math.round((timerSeconds03 / 1800) * 100);
  const color03 = timerSeconds03 > 0 ? "#ff8c00" : "#2f9281";

  const percent04 = Math.round((timerSeconds04 / 1800) * 100);
  const color04 = timerSeconds04 > 0 ? "#ff8c00" : "#2f9281";



  return (
    <>
      <HeaderCustom
        icon={
          shift?.SHIFT === "N" ? (
            <Tooltip title="กะ Night" arrow>
              <DarkModeOutlinedIcon style={{ color: "#ffffff" }} />
            </Tooltip>
          ) : (
            <Tooltip title="กะ Day" arrow>
              <LightModeOutlinedIcon style={{ color: "#ffffff" }} />
            </Tooltip>
          )
        }
      >
        ซองพักไก่
      </HeaderCustom>
      <Root>
        <Grid container spacing={0.5}>
          <Grid item xs={3}>
            <InfoCard
              sx={{ background: detail_lairage01?.STATUS_LAIRAGE === false ? '#bfbfbf' : timerSeconds01 > 0 ? "#f9c97b" : "#c0faec" }}
            >
              <Tooltip title="close lairage01" arrow>
                <IconButton
                  onClick={handleClickOpenCloseLairage01}
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 6,
                    color: detail_lairage01?.STATUS_LAIRAGE === true ? "#00d084" : "#595959"
                  }}
                >
                  <LensIcon sx={{ fontSize: 30 }} />
                </IconButton>
              </Tooltip>
              <Box
                sx={{
                  position: "absolute",
                  top: 3,
                  left: 6,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <CornerNumber>{1}</CornerNumber>
                <Tooltip title="add lairage01" arrow>
                  <EditNoteIcon
                    sx={{
                      position: "absolute",
                      top: 50,
                      left: 2,
                      display: "flex",
                      fontSize: 40,
                      cursor: "pointer",
                      "&:hover": { color: "#0077ff" },
                    }}
                    onClick={handleClickOpenLairage01}
                  />
                </Tooltip>
              </Box>

              <Box display="flex" justifyContent="center" sx={{ mt: 1 }}>
                {detail_lairage01?.STATUS_LAIRAGE === true ?
                  <TimerCircle percent={percent01} color={color01}>
                    <TimerInner>
                      {percent01 !== 0 ? (
                        <>
                          <Typography sx={{ lineHeight: 1.2, fontSize: "clamp(16px, 3vw, 32px)" }}>
                            {formatTime(timerSeconds01)}
                          </Typography>
                          <Typography sx={{ fontSize: "clamp(16px, 3vw, 32px)" }}>นาที</Typography>
                        </>
                      ) : (
                        <Typography variant="h5">เสร็จสิ้น</Typography>
                      )}
                    </TimerInner>
                  </TimerCircle>
                  : <Box sx={{ height: 222 }} />}
              </Box>
              <Grid container xs={12}>
                <Grid item xs={12} display={"flex"} justifyContent={"center"}>
                  {detail_lairage01?.STATUS_LAIRAGE === true ?
                    <Header sx={{ mt: 1, mb: 0.4 }}>
                      คิวที่ {detail_lairage01?.QUEUE_NUMBER} ไปที่{" "}
                      <span style={{ color: "#f30f07" }}>Line {detail_lairage01?.LINE_NUMBER}</span>
                    </Header> : ''}
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>ทะเบียน</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage01?.STATUS_LAIRAGE === true ? detail_lairage01?.LICENSE_PLATE : ''}</Labelvalue>
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>ฟาร์ม</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage01?.STATUS_LAIRAGE === true ? detail_lairage01?.FARM_NAME : ''}</Labelvalue>
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>เวลาเข้า</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage01?.STATUS_LAIRAGE === true ? moment(detail_lairage01?.ARRIVAL_TIMESTAMP?.toDate()).format("HH:mm:ss") : ''}</Labelvalue>
                </Grid>
                <Grid
                  container
                  xs={12}
                  display={"flex"}
                  justifyContent={"space-between"}
                >
                  <Grid container xs={6}>
                    <Grid item xs={6}>
                      <LabelBox>Temp</LabelBox>
                    </Grid>
                    <Grid item xs={6}>
                      <Labelvalue
                        sx={(Math.round(tempguard_01?.TEMP) < 17 || Math.round(tempguard_01?.TEMP) > 28) && { color: "#f30f07" }}
                      >
                        {Math.round(tempguard_01?.TEMP)} °C
                      </Labelvalue>
                    </Grid>
                  </Grid>
                  <Grid container xs={5}>
                    <Grid item xs={5}>
                      <LabelBox>%H</LabelBox>
                    </Grid>
                    <Grid item xs={7}>
                      <Labelvalue sx={Math.round(tempguard_01?.HUMID) < 50 && { color: "#f30f07" }}>
                        {Math.round(tempguard_01?.HUMID)} %
                      </Labelvalue>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </InfoCard>
          </Grid>

          <Grid item xs={3}>
            <InfoCard
              sx={{ background: detail_lairage02?.STATUS_LAIRAGE === false ? '#bfbfbf' : timerSeconds02 > 0 ? "#f9c97b" : "#c0faec" }}
            >
              <Tooltip title="close lairage02" arrow>
                <IconButton
                  onClick={handleClickOpenCloseLairage02}
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 6,
                    color: detail_lairage02?.STATUS_LAIRAGE === true ? "#00d084" : "#595959"
                  }}
                >
                  <LensIcon sx={{ fontSize: 30 }} />
                </IconButton>
              </Tooltip>
              <Box
                sx={{
                  position: "absolute",
                  top: 3,
                  left: 6,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <CornerNumber>{2}</CornerNumber>
                <Tooltip title="add lairage02" arrow>
                  <EditNoteIcon
                    sx={{
                      position: "absolute",
                      top: 50,
                      left: 2,
                      display: "flex",
                      fontSize: 40,
                      cursor: "pointer",
                      "&:hover": { color: "#0077ff" },
                    }}
                    onClick={handleClickOpenLairage02}
                  />
                </Tooltip>
              </Box>

              <Box display="flex" justifyContent="center" sx={{ mt: 1 }}>
                {detail_lairage02?.STATUS_LAIRAGE === true ?
                  <TimerCircle percent={percent02} color={color02}>
                    <TimerInner>
                      {percent02 !== 0 ? (
                        <>
                          <Typography sx={{ lineHeight: 1.2, fontSize: "clamp(16px, 3vw, 32px)" }}>
                            {formatTime(timerSeconds02)}
                          </Typography>
                          <Typography sx={{ fontSize: "clamp(16px, 3vw, 32px)" }}>นาที</Typography>
                        </>
                      ) : (
                        <Typography variant="h5">เสร็จสิ้น</Typography>
                      )}
                    </TimerInner>
                  </TimerCircle>
                  : <Box sx={{ height: 222 }} />}
              </Box>
              <Grid container xs={12}>
                <Grid item xs={12} display={"flex"} justifyContent={"center"}>
                  {detail_lairage02?.STATUS_LAIRAGE === true ?
                    <Header sx={{ mt: 1, mb: 0.4 }}>
                      คิวที่ {detail_lairage02?.QUEUE_NUMBER} ไปที่{" "}
                      <span style={{ color: "#f30f07" }}>Line {detail_lairage02?.LINE_NUMBER}</span>
                    </Header> : ''}
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>ทะเบียน</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage02?.STATUS_LAIRAGE === true ? detail_lairage02?.LICENSE_PLATE : ''}</Labelvalue>
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>ฟาร์ม</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage02?.STATUS_LAIRAGE === true ? detail_lairage02?.FARM_NAME : ''}</Labelvalue>
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>เวลาเข้า</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage02?.STATUS_LAIRAGE === true ? moment(detail_lairage02?.ARRIVAL_TIMESTAMP?.toDate()).format("HH:mm:ss") : ''}</Labelvalue>
                </Grid>
                <Grid
                  container
                  xs={12}
                  display={"flex"}
                  justifyContent={"space-between"}
                >
                  <Grid container xs={6}>
                    <Grid item xs={6}>
                      <LabelBox>Temp</LabelBox>
                    </Grid>
                    <Grid item xs={6}>
                      <Labelvalue
                        sx={(Math.round(tempguard_03?.TEMP) < 17 || Math.round(tempguard_03?.TEMP) > 28) && { color: "#f30f07" }}
                      >
                        {Math.round(tempguard_03?.TEMP)} °C
                      </Labelvalue>
                    </Grid>
                  </Grid>
                  <Grid container xs={5}>
                    <Grid item xs={5}>
                      <LabelBox>%H</LabelBox>
                    </Grid>
                    <Grid item xs={7}>
                      <Labelvalue sx={Math.round(tempguard_03?.HUMID) < 50 && { color: "#f30f07" }}>
                        {Math.round(tempguard_03?.HUMID)} %
                      </Labelvalue>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </InfoCard>
          </Grid>

          <Grid item xs={3}>
            <InfoCard
              sx={{ background: detail_lairage03?.STATUS_LAIRAGE === false ? '#bfbfbf' : timerSeconds03 > 0 ? "#f9c97b" : "#c0faec" }}
            >
              <Tooltip title="close lairage03" arrow>
                <IconButton
                  onClick={handleClickOpenCloseLairage03}
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 6,
                    color: detail_lairage03?.STATUS_LAIRAGE === true ? "#00d084" : "#595959"
                  }}
                >
                  <LensIcon sx={{ fontSize: 30 }} />
                </IconButton>
              </Tooltip>
              <Box
                sx={{
                  position: "absolute",
                  top: 3,
                  left: 6,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <CornerNumber>{3}</CornerNumber>
                <Tooltip title="add lairage03" arrow>
                  <EditNoteIcon
                    sx={{
                      position: "absolute",
                      top: 50,
                      left: 2,
                      display: "flex",
                      fontSize: 40,
                      cursor: "pointer",
                      "&:hover": { color: "#0077ff" },
                    }}
                    onClick={handleClickOpenLairage03}
                  />
                </Tooltip>
              </Box>

              <Box display="flex" justifyContent="center" sx={{ mt: 1 }}>
                {detail_lairage03?.STATUS_LAIRAGE === true ?
                  <TimerCircle percent={percent03} color={color03}>
                    <TimerInner>
                      {percent03 !== 0 ? (
                        <>
                          <Typography sx={{ lineHeight: 1.2, fontSize: "clamp(16px, 3vw, 32px)" }}>
                            {formatTime(timerSeconds03)}
                          </Typography>
                          <Typography sx={{ fontSize: "clamp(16px, 3vw, 32px)" }}>นาที</Typography>
                        </>
                      ) : (
                        <Typography variant="h5">เสร็จสิ้น</Typography>
                      )}
                    </TimerInner>
                  </TimerCircle>
                  : <Box sx={{ height: 222 }} />}
              </Box>
              <Grid container xs={12}>
                <Grid item xs={12} display={"flex"} justifyContent={"center"}>
                  {detail_lairage03?.STATUS_LAIRAGE === true ?
                    <Header sx={{ mt: 1, mb: 0.4 }}>
                      คิวที่ {detail_lairage03?.QUEUE_NUMBER} ไปที่{" "}
                      <span style={{ color: "#f30f07" }}>Line {detail_lairage03?.LINE_NUMBER}</span>
                    </Header> : ''}
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>ทะเบียน</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage03?.STATUS_LAIRAGE === true ? detail_lairage03?.LICENSE_PLATE : ''}</Labelvalue>
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>ฟาร์ม</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage03?.STATUS_LAIRAGE === true ? detail_lairage03?.FARM_NAME : ''}</Labelvalue>
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>เวลาเข้า</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage03?.STATUS_LAIRAGE === true ? moment(detail_lairage03?.ARRIVAL_TIMESTAMP?.toDate()).format("HH:mm:ss") : ''}</Labelvalue>
                </Grid>
                <Grid
                  container
                  xs={12}
                  display={"flex"}
                  justifyContent={"space-between"}
                >
                  <Grid container xs={6}>
                    <Grid item xs={6}>
                      <LabelBox>Temp</LabelBox>
                    </Grid>
                    <Grid item xs={6}>
                      <Labelvalue
                        sx={(Math.round(tempguard_04?.TEMP) < 17 || Math.round(tempguard_04?.TEMP) > 28) && { color: "#f30f07" }}
                      >
                        {Math.round(tempguard_04?.TEMP)} °C
                      </Labelvalue>
                    </Grid>
                  </Grid>
                  <Grid container xs={5}>
                    <Grid item xs={5}>
                      <LabelBox>%H</LabelBox>
                    </Grid>
                    <Grid item xs={7}>
                      <Labelvalue sx={Math.round(tempguard_04?.HUMID) < 50 && { color: "#f30f07" }}>
                        {Math.round(tempguard_04?.HUMID)} %
                      </Labelvalue>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </InfoCard>
          </Grid>

          <Grid item xs={3}>
            <InfoCard
              sx={{ background: detail_lairage04?.STATUS_LAIRAGE === false ? '#bfbfbf' : timerSeconds04 > 0 ? "#f9c97b" : "#c0faec" }}
            >
              <Tooltip title="close lairage04" arrow>
                <IconButton
                  onClick={handleClickOpenCloseLairage04}
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 6,
                    color: detail_lairage04?.STATUS_LAIRAGE === true ? "#00d084" : "#595959"
                  }}
                >
                  <LensIcon sx={{ fontSize: 30 }} />
                </IconButton>
              </Tooltip>
              <Box
                sx={{
                  position: "absolute",
                  top: 3,
                  left: 6,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <CornerNumber>{4}</CornerNumber>
                <Tooltip title="add lairage04" arrow>
                  <EditNoteIcon
                    sx={{
                      position: "absolute",
                      top: 50,
                      left: 2,
                      display: "flex",
                      fontSize: 40,
                      cursor: "pointer",
                      "&:hover": { color: "#0077ff" },
                    }}
                    onClick={handleClickOpenLairage04}
                  />
                </Tooltip>
              </Box>

              <Box display="flex" justifyContent="center" sx={{ mt: 1 }}>
                {detail_lairage04?.STATUS_LAIRAGE === true ?
                  <TimerCircle percent={percent04} color={color04}>
                    <TimerInner>
                      {percent04 !== 0 ? (
                        <>
                          <Typography sx={{ lineHeight: 1.2, fontSize: "clamp(16px, 3vw, 32px)" }}>
                            {formatTime(timerSeconds04)}
                          </Typography>
                          <Typography sx={{ fontSize: "clamp(16px, 3vw, 32px)" }}>นาที</Typography>
                        </>
                      ) : (
                        <Typography variant="h5">เสร็จสิ้น</Typography>
                      )}
                    </TimerInner>
                  </TimerCircle>
                  : <Box sx={{ height: 222 }} />}
              </Box>
              <Grid container xs={12}>
                <Grid item xs={12} display={"flex"} justifyContent={"center"}>
                  {detail_lairage04?.STATUS_LAIRAGE === true ?
                    <Header sx={{ mt: 1, mb: 0.4 }}>
                      คิวที่ {detail_lairage04?.QUEUE_NUMBER} ไปที่{" "}
                      <span style={{ color: "#f30f07" }}>Line {detail_lairage04?.LINE_NUMBER}</span>
                    </Header> : ''}
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>ทะเบียน</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage04?.STATUS_LAIRAGE === true ? detail_lairage04?.LICENSE_PLATE : ''}</Labelvalue>
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>ฟาร์ม</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage04?.STATUS_LAIRAGE === true ? detail_lairage04?.FARM_NAME : ''}</Labelvalue>
                </Grid>
                <Grid item xs={4}>
                  <LabelBox>เวลาเข้า</LabelBox>
                </Grid>
                <Grid item xs={8}>
                  <Labelvalue>{detail_lairage04?.STATUS_LAIRAGE === true ? moment(detail_lairage04?.ARRIVAL_TIMESTAMP?.toDate()).format("HH:mm:ss") : ''}</Labelvalue>
                </Grid>
                <Grid
                  container
                  xs={12}
                  display={"flex"}
                  justifyContent={"space-between"}
                >
                  <Grid container xs={6}>
                    <Grid item xs={6}>
                      <LabelBox>Temp</LabelBox>
                    </Grid>
                    <Grid item xs={6}>
                      <Labelvalue
                        sx={(Math.round(tempguard_05?.TEMP) < 17 || Math.round(tempguard_05?.TEMP) > 28) && { color: "#f30f07" }}
                      >
                        {Math.round(tempguard_05?.TEMP)} °C
                      </Labelvalue>
                    </Grid>
                  </Grid>
                  <Grid container xs={5}>
                    <Grid item xs={5}>
                      <LabelBox>%H</LabelBox>
                    </Grid>
                    <Grid item xs={7}>
                      <Labelvalue sx={Math.round(tempguard_05?.HUMID) < 50 && { color: "#f30f07" }}>
                        {Math.round(tempguard_05?.HUMID)} %
                      </Labelvalue>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </InfoCard>
          </Grid>
        </Grid>
      </Root>
      {/* Lairage 01*/}
      <Dialog
        open={openLairage01}
        onClose={handleCloseLairage01}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          Add Lairage 01
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item md={6} xs={6}>
              <TextField

                fullWidth
                label="Queue Number"
                name="queue_number01"
                required
                value={addQueueNumber01}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage01}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="Line Number"
                name="line_number01"
                required
                value={addLineNumber01}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage01}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="License Plate"
                name="license_plate01"
                required
                value={addLicensePlate01}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage01}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="Farm Name"
                name="farm_name01"
                required
                value={addFarmName01}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage01}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseLairage01(false)}>Cancel</Button>
          <Button disabled={!addQueueNumber01 || !addLineNumber01 || !addLicensePlate01 || !addFarmName01} onClick={() => { handleCloseLairage01(false); handleSubmitAddLairage01(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>

      {/* Lairage 02*/}
      <Dialog
        open={openLairage02}
        onClose={handleCloseLairage02}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          Add Lairage 02
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item md={6} xs={6}>
              <TextField

                fullWidth
                label="Queue Number"
                name="queue_number02"
                required
                value={addQueueNumber02}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage02}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="Line Number"
                name="line_number02"
                required
                value={addLineNumber02}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage02}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="License Plate"
                name="license_plate02"
                required
                value={addLicensePlate02}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage02}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="Farm Name"
                name="farm_name02"
                required
                value={addFarmName02}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage02}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseLairage02(false)}>Cancel</Button>
          <Button disabled={!addQueueNumber02 || !addLineNumber02 || !addLicensePlate02 || !addFarmName02} onClick={() => { handleCloseLairage02(false); handleSubmitAddLairage02(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>

      {/* Lairage 03*/}
      <Dialog
        open={openLairage03}
        onClose={handleCloseLairage03}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          Add Lairage 03
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item md={6} xs={6}>
              <TextField

                fullWidth
                label="Queue Number"
                name="queue_number03"
                required
                value={addQueueNumber03}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage03}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="Line Number"
                name="line_number03"
                required
                value={addLineNumber03}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage03}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="License Plate"
                name="license_plate03"
                required
                value={addLicensePlate03}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage03}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="Farm Name"
                name="farm_name03"
                required
                value={addFarmName03}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage03}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseLairage03(false)}>Cancel</Button>
          <Button disabled={!addQueueNumber03 || !addLineNumber03 || !addLicensePlate03 || !addFarmName03} onClick={() => { handleCloseLairage03(false); handleSubmitAddLairage03(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>

      {/* Lairage 04*/}
      <Dialog
        open={openLairage04}
        onClose={handleCloseLairage04}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          Add Lairage 04
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item md={6} xs={6}>
              <TextField

                fullWidth
                label="Queue Number"
                name="queue_number04"
                required
                value={addQueueNumber04}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage04}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="Line Number"
                name="line_number04"
                required
                value={addLineNumber04}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage04}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="License Plate"
                name="license_plate04"
                required
                value={addLicensePlate04}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage04}
              />
            </Grid>

            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                label="Farm Name"
                name="farm_name04"
                required
                value={addFarmName04}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddLairage04}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseLairage04(false)}>Cancel</Button>
          <Button disabled={!addQueueNumber04 || !addLineNumber04 || !addLicensePlate04 || !addFarmName04} onClick={() => { handleCloseLairage04(false); handleSubmitAddLairage04(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>

      {/* Close Lairage 01*/}
      <Dialog
        open={openCloseLairage01}
        onClose={handleCloseCloseLairage01}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          ยืนยันนำรถออกจากซองพักไก่ 1
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => handleCloseCloseLairage01(false)}>Cancel</Button>
          <Button onClick={() => { handleCloseCloseLairage01(false); handleSubmitCloseLairage01(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>

      {/* Close Lairage 02*/}
      <Dialog
        open={openCloseLairage02}
        onClose={handleCloseCloseLairage02}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          ยืนยันนำรถออกจากซองพักไก่ 2
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => handleCloseCloseLairage02(false)}>Cancel</Button>
          <Button onClick={() => { handleCloseCloseLairage02(false); handleSubmitCloseLairage02(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>

      {/* Close Lairage 03*/}
      <Dialog
        open={openCloseLairage03}
        onClose={handleCloseCloseLairage03}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          ยืนยันนำรถออกจากซองพักไก่ 3
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => handleCloseCloseLairage03(false)}>Cancel</Button>
          <Button onClick={() => { handleCloseCloseLairage03(false); handleSubmitCloseLairage03(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>

      {/* Close Lairage 04*/}
      <Dialog
        open={openCloseLairage04}
        onClose={handleCloseCloseLairage04}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          ยืนยันนำรถออกจากซองพักไก่ 4
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => handleCloseCloseLairage04(false)}>Cancel</Button>
          <Button onClick={() => { handleCloseCloseLairage04(false); handleSubmitCloseLairage04(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

